var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38039 19.3777C8.65483 19.6524 8.52496 20.1215 8.14837 20.216L4.15639 21.2138C3.7902 21.3054 3.45856 20.9737 3.55011 20.6075L4.54793 16.6156C4.64244 16.239 5.11151 16.1091 5.38624 16.3836L8.38039 19.3777Z",
    fill: "#0F2A40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8016 5.93577C22.1218 6.32854 22.0986 6.90797 21.7326 7.27403L11.126 17.8806C10.7599 18.2467 10.1805 18.2699 9.7877 17.9497L9.71174 17.8806L6.88331 15.0522C6.51726 14.6861 6.49408 14.1067 6.81426 13.7139L6.88331 13.638L17.4899 3.03139C17.8804 2.64086 18.5136 2.64086 18.9041 3.03139L21.7326 5.85981L21.8016 5.93577ZM8.29753 14.3451L10.4188 16.4664L20.3183 6.56692L18.197 4.4456L8.29753 14.3451Z",
    fill: "#0F2A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.4cfbfbf4bcefd69c2dfa6d620eee82fd.svg";
export { ForwardRef as ReactComponent };